import React from "react";

const ListItem = ({ title, value }) => {
  return (
    <div className="flex-col justify-start items-start gap-1 inline-flex pb-4">
      <div className="account-list-item-title text-sm font-normal leading-tight tracking-tight">
        {title}
      </div>
      <div className="account-list-item-sub-title text-sm font-medium leading-tight tracking-tight">
        {value}
      </div>
    </div>
  );
};

export default ListItem;
